import Axios from "../../../../networking/intraceptor";
import * as endPoints from '../../../../networking/urlEndPoints';
import { toast } from "react-toastify";
import { checkBookkeeperModuleAccess } from "../../../../screens/pharmacy/payroll/api/payrollApi";
// Helper function to generate action types with REQUEST, SUCCESS, and FAILURE
const createActionTypes = (base) => ({
    REQUEST: `${base}_REQUEST`,
    SUCCESS: `${base}_SUCCESS`,
    FAILURE: `${base}_FAILURE`
});

// Action Types
export const actionTypes = {
    UPDATE_LABEL_TO_MARGIN: createActionTypes('UPDATE_LABEL_TO_MARGIN'),
    UPDATE_LABEL_PRINT_HEADER: createActionTypes('UPDATE_LABEL_PRINT_HEADER'),
    UPDATE_LABEL_HEADER_TOP_MARGIN: createActionTypes('UPDATE_LABEL_HEADER_TOP_MARGIN'),
    UPDATE_LABEL_PRINT_TYPE: createActionTypes('UPDATE_LABEL_PRINT_TYPE'),
    UPDATE_LABEL_PRINT_LOGO: createActionTypes('UPDATE_LABEL_PRINT_LOGO'),
    UPDATE_LABEL_LEFT_MARGIN: createActionTypes('UPDATE_LABEL_LEFT_MARGIN'),
    UPDATE_LABEL_SIG_GAP: createActionTypes('UPDATE_LABEL_SIG_GAP'),
    PHARMACY_GET_CONSENT_EMAIL_DATA: createActionTypes('PHARMACY_GET_CONSENT_EMAIL_DATA'),
    PHARMACY_ADD_CONSENT_EMAIL_DATA: createActionTypes('PHARMACY_ADD_CONSENT_EMAIL_DATA'),
    PHARMACY_UPDATE_AUTHENTICATION_PHONE_NUMBER: createActionTypes('PHARMACY_UPDATE_AUTHENTICATION_PHONE_NUMBER'),
    PHARMACY_GET_AUTHENTICATION_PHONE_NUMBER: createActionTypes('PHARMACY_GET_AUTHENTICATION_PHONE_NUMBER'),
    GET_SEARCH_HISTORY: createActionTypes('GET_SEARCH_HISTORY'),
    STORE_SEARCH_HISTORY: 'STORE_SEARCH_HISTORY',
    UPDATE_PHARMACY_WITNESS_CARRY: createActionTypes('UPDATE_PHARMACY_WITNESS_CARRY'),
    CHECK_BOOKKEEPER_MODULE_ACCESS: createActionTypes('CHECK_BOOKKEEPER_MODULE_ACCESS'),
    CHECK_LOGS_EXISTS: createActionTypes('CHECK_LOGS_EXISTS'),
};

// Action Creators
export const createAction = (type, payload = {}) => ({ type, payload });

export const PharmacyUpdateLabelToMargin = ({ topmargin, fetchType }) => async (dispatch) => {
    dispatch(createAction(actionTypes.UPDATE_LABEL_TO_MARGIN.REQUEST, {
        requestType: fetchType
    }));

    try {
        const payload = {
            label_top_margin: topmargin
        }
        const response = await Axios.post(`${endPoints.pharmacy_update_label_to_margin}`, payload);
        if (response?.status === 200) {
            dispatch(createAction(actionTypes.UPDATE_LABEL_TO_MARGIN.SUCCESS, {
                data: response?.data?.data?.data,
                requestType: fetchType
            }));
            toast.success('Updated Successfully')
        }
    } catch (error) {
        const errMsg = error?.response?.data?.message || error.message || 'Something went wrong';
        dispatch(createAction(actionTypes.UPDATE_LABEL_TO_MARGIN.FAILURE, {
            error: errMsg,
            requestType: fetchType
        }));
        toast.error('Something went wrong')
    }
};


export const PharmacyUpdateLabelPrintHeader = ({ printHeader, fetchType }) => async (dispatch) => {
    dispatch(createAction(actionTypes.UPDATE_LABEL_PRINT_HEADER.REQUEST, {
        requestType: fetchType
    }));

    try {
        const payload = {
            label_print_header: printHeader ? 1 : 0
        }
        const response = await Axios.post(`${endPoints.pharmacy_update_label_to_margin}`, payload);
        if (response?.status === 200) {
            dispatch(createAction(actionTypes.UPDATE_LABEL_PRINT_HEADER.SUCCESS, {
                data: !!response?.data?.data?.label_print_header,
                requestType: fetchType
            }));
            toast.success('Updated Successfully')
            return true
        }
        return false
    } catch (error) {
        const errMsg = error?.response?.data?.message || error.message || 'Something went wrong';
        dispatch(createAction(actionTypes.UPDATE_LABEL_PRINT_HEADER.FAILURE, {
            error: errMsg,
            requestType: fetchType
        }));
        toast.error('Something went wrong')
        return false
    }
};

export const PharmacyUpdateLabelHeaderTopMargin = ({ headerTopMargin, fetchType }) => async (dispatch) => {
    dispatch(createAction(actionTypes.UPDATE_LABEL_HEADER_TOP_MARGIN.REQUEST, {
        requestType: fetchType
    }));

    try {
        const payload = {
            label_header_top_margin: headerTopMargin
        }
        const response = await Axios.post(`${endPoints.pharmacy_update_label_to_margin}`, payload);
        if (response?.status === 200) {
            dispatch(createAction(actionTypes.UPDATE_LABEL_HEADER_TOP_MARGIN.SUCCESS, {
                data: response?.data?.data?.label_header_top_margin,
                requestType: fetchType
            }));
            toast.success('Updated Successfully')
            return true
        }
        return false
    } catch (error) {
        const errMsg = error?.response?.data?.message || error.message || 'Something went wrong';
        dispatch(createAction(actionTypes.UPDATE_LABEL_HEADER_TOP_MARGIN.FAILURE, {
            error: errMsg,
            requestType: fetchType
        }));
        toast.error('Something went wrong')
        return false
    }
};

// "Reverse" switch: 'toptodown' prints the label rotated 180deg, 'regular' is normal.
export const PharmacyUpdateLabelPrintType = ({ printType, fetchType }) => async (dispatch) => {
    dispatch(createAction(actionTypes.UPDATE_LABEL_PRINT_TYPE.REQUEST, {
        requestType: fetchType
    }));

    try {
        const payload = {
            label_print_type: printType
        }
        const response = await Axios.post(`${endPoints.pharmacy_update_label_to_margin}`, payload);
        if (response?.status === 200) {
            dispatch(createAction(actionTypes.UPDATE_LABEL_PRINT_TYPE.SUCCESS, {
                data: response?.data?.data?.label_print_type || 'regular',
                requestType: fetchType
            }));
            toast.success('Updated Successfully')
            return true
        }
        return false
    } catch (error) {
        const errMsg = error?.response?.data?.message || error.message || 'Something went wrong';
        dispatch(createAction(actionTypes.UPDATE_LABEL_PRINT_TYPE.FAILURE, {
            error: errMsg,
            requestType: fetchType
        }));
        toast.error('Something went wrong')
        return false
    }
};

// "Pharmacy logo" checkbox: prints the pharmacy's uploaded logo in the label header.
export const PharmacyUpdateLabelPrintLogo = ({ printLogo, fetchType }) => async (dispatch) => {
    dispatch(createAction(actionTypes.UPDATE_LABEL_PRINT_LOGO.REQUEST, {
        requestType: fetchType
    }));

    try {
        const payload = {
            label_print_logo: printLogo ? 1 : 0
        }
        const response = await Axios.post(`${endPoints.pharmacy_update_label_to_margin}`, payload);
        if (response?.status === 200) {
            dispatch(createAction(actionTypes.UPDATE_LABEL_PRINT_LOGO.SUCCESS, {
                data: !!response?.data?.data?.label_print_logo,
                requestType: fetchType
            }));
            toast.success('Updated Successfully')
            return true
        }
        return false
    } catch (error) {
        const errMsg = error?.response?.data?.message || error.message || 'Something went wrong';
        dispatch(createAction(actionTypes.UPDATE_LABEL_PRINT_LOGO.FAILURE, {
            error: errMsg,
            requestType: fetchType
        }));
        toast.error('Something went wrong')
        return false
    }
};

// Numeric label settings that save one field each: "Label left margin"
// (label_left_margin) and "Space after SIG" (label_sig_gap).
const updateLabelNumberSetting = (types, field) => ({ value, fetchType }) => async (dispatch) => {
    dispatch(createAction(types.REQUEST, {
        requestType: fetchType
    }));

    try {
        const response = await Axios.post(`${endPoints.pharmacy_update_label_to_margin}`, { [field]: value });
        if (response?.status === 200) {
            dispatch(createAction(types.SUCCESS, {
                data: response?.data?.data?.[field] ?? 0,
                requestType: fetchType
            }));
            toast.success('Updated Successfully')
            return true
        }
        return false
    } catch (error) {
        const errMsg = error?.response?.data?.message || error.message || 'Something went wrong';
        dispatch(createAction(types.FAILURE, {
            error: errMsg,
            requestType: fetchType
        }));
        toast.error('Something went wrong')
        return false
    }
};

export const PharmacyUpdateLabelLeftMargin = updateLabelNumberSetting(actionTypes.UPDATE_LABEL_LEFT_MARGIN, 'label_left_margin')
export const PharmacyUpdateLabelSigGap = updateLabelNumberSetting(actionTypes.UPDATE_LABEL_SIG_GAP, 'label_sig_gap')

// Login is the only place the label settings are loaded, so after a page
// refresh the store is empty. The Label Setting popup calls this on open to
// re-sync the saved values (silently - no toast, no loading state).
export const PharmacySyncLabelSettings = () => async (dispatch) => {
    try {
        const response = await Axios.get('pharmacy-all-setting');
        const settings = response?.status === 200 ? response?.data?.data : null
        if (!settings) return null

        if (settings.label_top_margin !== undefined && settings.label_top_margin !== '') {
            dispatch(createAction(actionTypes.UPDATE_LABEL_TO_MARGIN.SUCCESS, {
                data: settings.label_top_margin,
                requestType: 'updateLabelToMargin'
            }));
        }

        dispatch(createAction(actionTypes.UPDATE_LABEL_PRINT_HEADER.SUCCESS, {
            data: !!settings.label_print_header,
            requestType: 'updateLabelPrintHeader'
        }));
        dispatch(createAction(actionTypes.UPDATE_LABEL_HEADER_TOP_MARGIN.SUCCESS, {
            data: settings.label_header_top_margin ?? 0,
            requestType: 'updateLabelHeaderTopMargin'
        }));
        dispatch(createAction(actionTypes.UPDATE_LABEL_PRINT_TYPE.SUCCESS, {
            data: settings.label_print_type || 'regular',
            requestType: 'updateLabelPrintType'
        }));
        dispatch(createAction(actionTypes.UPDATE_LABEL_PRINT_LOGO.SUCCESS, {
            data: !!settings.label_print_logo,
            requestType: 'updateLabelPrintLogo'
        }));
        dispatch(createAction(actionTypes.UPDATE_LABEL_LEFT_MARGIN.SUCCESS, {
            data: settings.label_left_margin ?? 0,
            requestType: 'updateLabelLeftMargin'
        }));
        dispatch(createAction(actionTypes.UPDATE_LABEL_SIG_GAP.SUCCESS, {
            data: settings.label_sig_gap ?? 0,
            requestType: 'updateLabelSigGap'
        }));
        return settings
    } catch (error) {
        // Keep whatever the store already has.
        return null
    }
};

// The Label Setting popup's single "Update" button: saves every label setting
// in one request, then updates each value in the store.
export const PharmacySaveLabelSettings = (payload) => async (dispatch) => {
    try {
        const response = await Axios.post(`${endPoints.pharmacy_update_label_to_margin}`, payload);
        const saved = response?.status === 200 ? response?.data?.data : null
        if (!saved) {
            toast.error('Something went wrong')
            return false
        }

        const results = [
            [actionTypes.UPDATE_LABEL_TO_MARGIN, 'updateLabelToMargin', saved.label_top_margin],
            [actionTypes.UPDATE_LABEL_PRINT_HEADER, 'updateLabelPrintHeader', !!saved.label_print_header],
            [actionTypes.UPDATE_LABEL_HEADER_TOP_MARGIN, 'updateLabelHeaderTopMargin', saved.label_header_top_margin ?? 0],
            [actionTypes.UPDATE_LABEL_PRINT_TYPE, 'updateLabelPrintType', saved.label_print_type || 'regular'],
            [actionTypes.UPDATE_LABEL_PRINT_LOGO, 'updateLabelPrintLogo', !!saved.label_print_logo],
            [actionTypes.UPDATE_LABEL_LEFT_MARGIN, 'updateLabelLeftMargin', saved.label_left_margin ?? 0],
            [actionTypes.UPDATE_LABEL_SIG_GAP, 'updateLabelSigGap', saved.label_sig_gap ?? 0],
        ]
        results.forEach(([types, requestType, data]) => {
            dispatch(createAction(types.SUCCESS, { data, requestType }));
        })

        toast.success('Updated Successfully')
        return true
    } catch (error) {
        toast.error(error?.response?.data?.message || 'Something went wrong')
        return false
    }
};

export const PharmacyGetAuthenticationPhoneNumber = ({ fetchType }) => async (dispatch) => {
    dispatch(createAction(actionTypes.PHARMACY_GET_AUTHENTICATION_PHONE_NUMBER.REQUEST, {
        requestType: fetchType
    }));
    try {
        const response = await Axios.get(`${endPoints.pharmacy_get_authentication_phone_number}`);
        if (response?.status === 200) {
            dispatch(createAction(actionTypes.PHARMACY_GET_AUTHENTICATION_PHONE_NUMBER.SUCCESS, {
                data: response?.data?.data,
                requestType: fetchType
            }));
        }
    } catch (error) {
        const errMsg = error?.response?.data?.message || error.message || 'Something went wrong';
        dispatch(createAction(actionTypes.PHARMACY_GET_AUTHENTICATION_PHONE_NUMBER.FAILURE, {
            error: errMsg,
            requestType: fetchType
        }));
    }
}

export const PharmacyUpdateAuthenticationPhoneNumber = ({auth_phones, fetchType }) => async (dispatch) => {
    dispatch(createAction(actionTypes.PHARMACY_UPDATE_AUTHENTICATION_PHONE_NUMBER.REQUEST, {
        requestType: fetchType
    }));
    try {
        const response = await Axios.post(`${endPoints.pharmacy_update_authentication_phone_number}`, {auth_phones });
        if (response?.status === 200) {
            // Refresh the phone numbers data after successful update
            dispatch(PharmacyGetAuthenticationPhoneNumber({ fetchType: 'pharmacyGetAuthenticationPhoneNumber' }))
            dispatch(createAction(actionTypes.PHARMACY_UPDATE_AUTHENTICATION_PHONE_NUMBER.SUCCESS, {
                data: response?.data?.data,
                requestType: fetchType
            }));
            toast.success('Updated Successfully', { autoClose: 3000 })
        }
    } catch (error) {
        const errMsg = error?.response?.data?.message || error.message || 'Something went wrong';
        dispatch(createAction(actionTypes.PHARMACY_UPDATE_AUTHENTICATION_PHONE_NUMBER.FAILURE, {
            error: errMsg,
            requestType: fetchType
        }));
        toast.error('Something went wrong', { autoClose: 3000 })
    }
};

export const PharmacyGetConsentEmailData = ({ fetchType }) => async (dispatch) => {
    dispatch(createAction(actionTypes.PHARMACY_GET_CONSENT_EMAIL_DATA.REQUEST, {
        requestType: fetchType
    }));

    try {
        const response = await Axios.get(`${endPoints.pharmacy_get_consent_email_data}`);
        if (response?.status === 200) {
            dispatch(createAction(actionTypes.PHARMACY_GET_CONSENT_EMAIL_DATA.SUCCESS, {
                data: response?.data?.data,
                requestType: fetchType
            }));
        }
    } catch (error) {
        const errMsg = error?.response?.data?.message || error.message || 'Something went wrong';
        dispatch(createAction(actionTypes.PHARMACY_GET_CONSENT_EMAIL_DATA.FAILURE, {
            error: errMsg,
            requestType: fetchType
        }));
    }
};

export const PharmacyAddConsentEmailData = ({ auth_emails, fetchType }) => async (dispatch) => {
    dispatch(createAction(actionTypes.PHARMACY_ADD_CONSENT_EMAIL_DATA.REQUEST, {
        requestType: fetchType
    }));

    try {
        const response = await Axios.post(`${endPoints.pharmacy_add_consent_email_data}`, { auth_emails });
        if (response?.status === 200) {
            dispatch(PharmacyGetConsentEmailData({ fetchType: 'pharmacyGetConsentEmailData' }))
            dispatch(createAction(actionTypes.PHARMACY_ADD_CONSENT_EMAIL_DATA.SUCCESS, {
                data: response?.data?.data,
                requestType: fetchType
            }));
            toast.success('Updated Successfully')
        }
    } catch (error) {
        const errMsg = error?.response?.data?.message || error.message || 'Something went wrong';
        dispatch(createAction(actionTypes.PHARMACY_ADD_CONSENT_EMAIL_DATA.FAILURE, {
            error: errMsg,
            requestType: fetchType
        }));
        toast.error('Something went wrong')
    }

};

export const GetSearchHistory = ({  fetchType, query }) => async (dispatch) => {
    dispatch(createAction(actionTypes.GET_SEARCH_HISTORY.REQUEST, {
        requestType: fetchType
    }));

    const params = {
        search: query
    }

    try {
        const response = await Axios.get(`${endPoints.pharmacy_get_search_history}`, { params });
        if (response?.status === 200) {
            dispatch(createAction(actionTypes.GET_SEARCH_HISTORY.SUCCESS, {
                data: response?.data?.data,
                requestType: fetchType
            }));
            
        }
    } catch (error) {
        const errMsg = error?.response?.data?.message || error.message || 'Something went wrong';
        dispatch(createAction(actionTypes.GET_SEARCH_HISTORY.FAILURE, {
            error: errMsg,
            requestType: fetchType
        }));
    }

};

// Witness Carry Setting Thunk
export const updatePharmacyWitnessCarry = (value) => async (dispatch, getState) => {
    const prevValue = getState()?.commonReducerForInitalData?.witnessCarry?.value ?? 0;
    dispatch(createAction(actionTypes.UPDATE_PHARMACY_WITNESS_CARRY.REQUEST, { value }));
    try {
        const response = await Axios.post(`pharmacy-update-setting`, { auto_carry_witness: value });
        if (response?.status === 200) {
            dispatch(
                createAction(actionTypes.UPDATE_PHARMACY_WITNESS_CARRY.SUCCESS, {
                    data: response?.data?.data?.auto_carry_witness,
                })
            );
            toast.success('Setting updated successfully.');
        }
    } catch (error) {
        const errMsg = error?.response?.data?.message || error.message || 'Something went wrong';
        dispatch(
            createAction(actionTypes.UPDATE_PHARMACY_WITNESS_CARRY.FAILURE, {
                error: errMsg,
                prevValue,
            })
        );
        toast.error(errMsg);
    }
};

// New action to store search history without loading
export const StoreSearchHistory = (searchHistoryData) => (dispatch) => {
    dispatch(createAction(actionTypes.STORE_SEARCH_HISTORY, {
        data: searchHistoryData,
        requestType: 'storeSearchHistory'
    }));
};

// Check Bookkeeper Module Access
export const CheckBookkeeperModuleAccess = ({ fetchType }) => async (dispatch) => {
    dispatch(createAction(actionTypes.CHECK_BOOKKEEPER_MODULE_ACCESS.REQUEST, {
        requestType: fetchType
    }));

    try {
        const response = await checkBookkeeperModuleAccess();
        if (response?.status === 200 && response?.data?.status === 'success') {
            dispatch(createAction(actionTypes.CHECK_BOOKKEEPER_MODULE_ACCESS.SUCCESS, {
                data: response?.data?.data,
                requestType: fetchType
            }));
        } else {
            throw new Error(response?.data?.message || 'Failed to check bookkeeper module access');
        }
    } catch (error) {
        const errMsg = error?.response?.data?.message || error?.message || 'Something went wrong';
        dispatch(createAction(actionTypes.CHECK_BOOKKEEPER_MODULE_ACCESS.FAILURE, {
            error: errMsg,
            requestType: fetchType
        }));
    }
};

// Check Logs Exists
export const CheckLogsExists = ({ fetchType }) => async (dispatch) => {
    dispatch(createAction(actionTypes.CHECK_LOGS_EXISTS.REQUEST, {
        requestType: fetchType
    }));

    try {
        const response = await Axios.get(`${endPoints.check_logs_exists}`);
        if (response?.status === 200) {
            dispatch(createAction(actionTypes.CHECK_LOGS_EXISTS.SUCCESS, {
                data: response?.data?.data,
                requestType: fetchType
            }));
        }
    } catch (error) {
        const errMsg = error?.response?.data?.message || error?.message || 'Something went wrong';
        dispatch(createAction(actionTypes.CHECK_LOGS_EXISTS.FAILURE, {
            error: errMsg,
            requestType: fetchType
        }));
    }
};

const stateKeys = [
    'updateLabelToMargin',
    'updateLabelPrintHeader',
    'updateLabelHeaderTopMargin',
    'updateLabelPrintType',
    'updateLabelPrintLogo',
    'updateLabelLeftMargin',
    'updateLabelSigGap',
    'pharmacyGetConsentEmailData',
    'pharmacyAddConsentEmailData',
    'pharmacyUpdateAuthenticationPhoneNumber',
    'pharmacyGetAuthenticationPhoneNumber',
    'getSearchHistory',
    'storeSearchHistory',
    'witnessCarry',
    'bookkeeperModuleAccess',
    'checkLogsExists'
];

const createDefaultState = () => ({
    loading: false,
    error: null,
    data: null,
    fetchType: null,
});

const initialState = stateKeys.reduce((acc, key) => {
    acc[key] = createDefaultState();
    return acc;
}, {});

// Witness Carry slice initial state
initialState.witnessCarry = {
    value: 0,
    isLoading: false,
    error: null,
    lastSavedAt: null,
};

// Helper function to update state
const updateState = (state, key, updates) => ({
    ...state,
    [key]: { ...state[key], ...updates }
});

// Map action prefixes to state keys
const actionPrefixMap = {
    UPDATE_LABEL_TO_MARGIN: 'updateLabelToMargin',
    UPDATE_LABEL_PRINT_HEADER: 'updateLabelPrintHeader',
    UPDATE_LABEL_HEADER_TOP_MARGIN: 'updateLabelHeaderTopMargin',
    UPDATE_LABEL_PRINT_TYPE: 'updateLabelPrintType',
    UPDATE_LABEL_PRINT_LOGO: 'updateLabelPrintLogo',
    UPDATE_LABEL_LEFT_MARGIN: 'updateLabelLeftMargin',
    UPDATE_LABEL_SIG_GAP: 'updateLabelSigGap',
    PHARMACY_GET_CONSENT_EMAIL_DATA: 'pharmacyGetConsentEmailData',
    PHARMACY_ADD_CONSENT_EMAIL_DATA: 'pharmacyAddConsentEmailData',
    PHARMACY_UPDATE_AUTHENTICATION_PHONE_NUMBER: 'pharmacyUpdateAuthenticationPhoneNumber',
    PHARMACY_GET_AUTHENTICATION_PHONE_NUMBER: 'pharmacyGetAuthenticationPhoneNumber',
    GET_SEARCH_HISTORY: 'getSearchHistory',
    STORE_SEARCH_HISTORY: 'storeSearchHistory',
    UPDATE_PHARMACY_WITNESS_CARRY: 'witnessCarry',
    CHECK_BOOKKEEPER_MODULE_ACCESS: 'bookkeeperModuleAccess',
    CHECK_LOGS_EXISTS: 'checkLogsExists'
};

// Helper function to get updates based on action status
const getStatusUpdates = (status, payload) => ({
    REQUEST: { loading: true, data: null, error: null, fetchType: payload.requestType },
    SUCCESS: { loading: false, error: null, data: payload.data, fetchType: payload.requestType },
    FAILURE: { loading: false, error: payload.error, data: null, fetchType: payload.requestType }
}[status]);

// Reducer
const CommonReducerForInitalData = (state = initialState, { type, payload }) => {

    // Special case for STORE_SEARCH_HISTORY action
    if (type === actionTypes.STORE_SEARCH_HISTORY) {
        return updateState(state, 'storeSearchHistory', {
            loading: false,
            error: null,
            data: payload.data,
            fetchType: payload.requestType,
        });
    }

    const typeParts = type.split('_');
    const status = typeParts.pop();
    const prefix = typeParts.join('_');
    const key = actionPrefixMap[prefix];

    if (!key) return state;

    const updates = getStatusUpdates(status, payload);
    return updates ? updateState(state, key, updates) : state;
};

export default CommonReducerForInitalData;

// Selector

